// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4345":"9e962f7a","8157":"9e962f7a"}[chunkId] + ".chunk.css";
};